import { User } from "../types";

export function usersFullName(user: User): string {
  return `${user?.firstName} ${user?.lastName}`;
}
